import React from "react";
import Carousel from "../Basic/Carousel";
import Feedback from "../Basic/Feedback";
import userStanley from "../../assets/user-stanley.png";
import userShirin from "../../assets/user-shirin.png";
import userMargaret from "../../assets/user-margaret.png";
import userAmanda from "../../assets/user-amanda.png";

const trustedItems = [
  <Feedback
    className="lg:h-60"
    name="Shirin Peters, MD"
    position="Bethany Medical Clinic"
    photo={userShirin}
    feedback="“[The] biggest benefit to using [Quadrant AI] in our practice is increasing bandwidth of providers to communciate effectively when they're outside the clinic. Overwhelming digital and phone communications are an enormous pain point.”"
  />,
  <Feedback
    className="lg:h-60"
    name="Stanley Dao, MD, CM, MBA"
    position="Centre Médical Mieux-Être"
    photo={userStanley}
    feedback="“Using Quadrant AI has been incredibly positive. It's shifted the way I think about care management and patient intake. Since I'm spending less time documenting, I can fully concentrate on patient interaction.”"
  />,
  <Feedback
    className="lg:h-60"
    name="Margaret Smith"
    position="Director of Operations, Stanford HEART"
    photo={userMargaret}
    feedback="“Having worked with many health technology companies, Quadrant Health's expertise in AI and ability to adapt in a rapidly changing field sets them apart. During our multi-year collaboration they've demonstrated a deep appreciation for clinical workflows and sharp focus on solving important problems for patients and providers.”"
  />,
  <Feedback
    className="lg:h-60"
    name="Amanda Laramie, COO"
    position="Coleman Associates"
    photo={userAmanda}
    feedback="“We're thrilled to see innovative software companies like Quadrant Health leveraging technology to streamline human processes and enhance patient access.”"
  />,
];

const Trusted = () => {
  return (
    <div className="px-5 lg:px-10 py-14 lg:py-24 w-full">
      <div className="w-full lg:max-w-7xl mx-auto flex flex-col items-center justify-center space-y-8 lg:space-y-10 ">
        <h2 className="text-10 header">Trusted by experts</h2>
        <div className="bg-slate-50 rounded-4xl px-6 lg:px-28 pt-6 lg:pt-8 pb-20 w-[85vw] lg:max-w-7xl">
          <Carousel items={trustedItems} />
        </div>
      </div>
    </div>
  );
};

export default Trusted;
